module.exports = __webpack_public_path__ + "images/icon/common_ic_remove_block-be71012a.svg";